module.exports = __webpack_public_path__ + "static/img/image-pro@2x.6879b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx-software/image-pro@2x.png
// module id = 2pk2
// module chunks = 12